import AppTooltip from "../../../elements/AppTooltip";
import AppSpinner from "../../../elements/AppSpinner";
import useHover from "../../../hooks/useHover";

interface Props {
  fileName: string;
  fileType: string;
  uploading: boolean;
  onDelete?: () => void;
  onClick?: () => void;
}

export default function BrieGPTFileIcon({
  fileName,
  fileType,
  uploading,
  onDelete,
  onClick,
}: Props) {
  const [hoverRef, isHovered] = useHover<HTMLDivElement>();

  const readableFileType = getReadableFileType(fileType);

  return (
    <AppTooltip content={fileName} placement="top" useTooltip>
      <div
        className="tw:relative tw:border tw:border-gray-200 tw:mb-1 tw:rounded tw:bg-superlight tw:flex tw:w-fit tw:cursor-pointer"
        ref={hoverRef}
        onClick={onClick}
      >
        {isHovered && !uploading && onDelete && (
          <div className="tw:z-1 tw:absolute tw:-top-2 tw:-right-2 tw:flex tw:items-center tw:justify-center  tw:bg-danger tw:rounded-full tw:size-5 tw:cursor-pointer">
            <i
              className="mdi mdi-close tw:leading-0 tw:text-white"
              onClick={onDelete}
            />
          </div>
        )}
        <div className="tw:relative">
          <i
            className={`mdi ${
              uploading
                ? "mdi-file-outline tw:text-gray-300"
                : "mdi-file-document-outline tw:text-gray-600"
            } tw:text-5xl `}
          />
          {uploading && (
            <AppSpinner
              size="sm"
              className="tw:absolute tw:top-12/20 tw:left-1/2 tw:-translate-x-1/2 tw:-translate-y-1/2"
            />
          )}
        </div>
        <div className="tw:flex tw:flex-col tw:justify-center tw:pr-2 tw:max-w-32">
          <div className="tw:text-xs tw:font-medium tw:truncate">
            {fileName}
          </div>
          <div className="tw:text-xs tw:font-semibold tw:truncate">
            {readableFileType}
          </div>
        </div>
      </div>
    </AppTooltip>
  );
}

function getReadableFileType(fileType: string) {
  if (!fileType || typeof fileType !== "string") {
    return "";
  }

  if (fileType.includes("officedocument")) {
    return "DOCX";
  }

  return fileType?.split?.("/")?.[1]?.toUpperCase();
}
